import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X, ArrowUp, Info } from "lucide-react";
import { CATEGORIES } from "@/constants/categories";

const PICKER = ["fashion", "phones", "electronics", "beauty", "home", "shoes", "computers", "jewelry", "automotive", "agriculture", "art", "grocery"];

export function FeedTabs({ tab, onTab, savedCount }) {
  const tabs = [["foryou", "For you"], ["new", "New"], ["saved", `Saved${savedCount ? ` · ${savedCount}` : ""}`]];
  return (
    <div className="flex items-center gap-1 rounded-full bg-[#121212] border border-[#27272A] p-1" data-testid="feed-tabs">
      {tabs.map(([k, label]) => (
        <button key={k} onClick={() => onTab(k)} data-testid={`feed-tab-${k === "foryou" ? "for-you" : k}`}
          className={`relative px-4 h-9 rounded-full text-sm font-bold tracking-wide transition-colors ${tab === k ? "text-black" : "text-zinc-400 hover:text-white"}`}>
          {tab === k && <motion.span layoutId="feed-tab-pill" className="absolute inset-0 rounded-full bg-white" transition={{ type: "spring", stiffness: 500, damping: 35 }} />}
          <span className="relative">{label}</span>
        </button>
      ))}
    </div>
  );
}

export function NewSincePill({ count, onClick }) {
  return (
    <AnimatePresence>
      {count > 0 && (
        <motion.button initial={{ y: -20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -20, opacity: 0 }} onClick={onClick} data-testid="feed-new-since-pill"
          className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full bg-[#007AFF] text-white text-xs font-semibold shadow-lg shadow-[#007AFF]/30">
          <ArrowUp className="h-3.5 w-3.5" /> {count} new since you left
        </motion.button>
      )}
    </AnimatePresence>
  );
}

export function InterestPicker({ selected, onChange, onDismiss }) {
  const [local, setLocal] = useState(selected || []);
  const toggle = (slug) => {
    const next = local.includes(slug) ? local.filter((s) => s !== slug) : [...local, slug].slice(0, 6);
    setLocal(next);
    onChange(next);
  };
  return (
    <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="rounded-2xl border border-[#27272A] bg-[#121212] p-4" data-testid="interest-picker">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#FF3B30] font-bold"><Sparkles className="h-3.5 w-3.5" /> Tune your feed</div>
          <p className="mt-1 text-sm text-zinc-400">Tap what you love — optional, we learn as you scroll anyway.</p>
        </div>
        <button onClick={onDismiss} aria-label="Dismiss" data-testid="interest-picker-dismiss" className="p-1.5 rounded-full text-zinc-500 hover:text-white hover:bg-white/10"><X className="h-4 w-4" /></button>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {PICKER.map((slug) => {
          const on = local.includes(slug);
          return (
            <button key={slug} onClick={() => toggle(slug)} data-testid={`category-chip-${slug}`}
              className={`h-8 px-3 rounded-full text-xs font-semibold border transition-colors ${on ? "bg-white text-black border-white" : "bg-transparent text-zinc-300 border-[#3F3F46] hover:border-white/50"}`}>
              {CATEGORIES.find((c) => c.slug === slug)?.label}
            </button>
          );
        })}
      </div>
    </motion.div>
  );
}

export function WelcomeStrip({ onDismiss }) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border border-[#27272A] bg-[#0E0E10] px-4 py-3 text-sm" data-testid="feed-welcome-strip">
      <span className="inline-flex items-center gap-2 text-zinc-300"><Info className="h-4 w-4 text-[#007AFF]" /> New here? <strong className="text-white">A million products, always live.</strong></span>
      <Link to="/welcome" data-testid="feed-welcome-link" className="text-[#007AFF] hover:underline font-semibold">How VISMARKS works</Link>
      <Link to="/register?role=seller" data-testid="feed-welcome-sell" className="text-[#FF8A80] hover:underline font-semibold">Sell — first month free</Link>
      <button onClick={onDismiss} aria-label="Dismiss" data-testid="feed-welcome-dismiss" className="ml-auto p-1 rounded-full text-zinc-500 hover:text-white"><X className="h-4 w-4" /></button>
    </div>
  );
}
